var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"outlined":"","tile":"","color":"primary"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-plus")]),_vm._t("default",[_vm._v(" Add New ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }